"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _app = require("@package/app");

var _moment = _interopRequireDefault(require("@package/moment"));

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultsModule = _interopRequireDefault(require("./defaults.module.scss"));

function Message(_ref) {
  var subject = _ref.subject,
      body = _ref.body,
      date = _ref.date;

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['wrapper']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['status']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Status, {
      form: "point",
      mode: "primary"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['title']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: "important"
    }, subject)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['description']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: "comment"
    }, body)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultsModule["default"]['date']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: "comment"
    }, (0, _moment["default"])(date).format('LL')))));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

Message.defaultProps = {
  title: '',
  description: '',
  date: ''
};
var _default = Message;
exports["default"] = _default;